<ui-card>
    <app-segment-header title="time-off-v3.policyComponents.settings.importTimeOffData.header"> </app-segment-header>

    <div class="cards-container">
        <ui-card
            [clickable]="true"
            [centered]="true"
            variant="outline"
            (click)="trackTimeOffRequestsDataImport()"
            role="link"
            [routerLink]="['/time-off', 'v3', 'import', 'time-off-importers', 'time-off-requests']"
        >
            <h3 class="no-margin font-light">
                {{ 'time-off-v3.policyComponents.settings.importTimeOffData.timeOffRequestsTitle' | translate }}
            </h3>
            <p class="subtitle">
                {{ 'time-off-v3.policyComponents.settings.importTimeOffData.timeOffRequestsSubtitle' | translate }}
            </p>
        </ui-card>
        <ui-card
            [clickable]="true"
            [centered]="true"
            variant="outline"
            (click)="trackTimeOffBalancesDataImport()"
            role="link"
            [routerLink]="['/time-off', 'v3', 'import', 'time-off-importers', 'time-off-balance']"
        >
            <h3 class="no-margin font-light">
                {{ 'time-off-v3.policyComponents.settings.importTimeOffData.timeOffBalancesTitle' | translate }}
            </h3>
            <p class="subtitle">
                {{ 'time-off-v3.policyComponents.settings.importTimeOffData.timeOffBalancesSubtitle' | translate }}
            </p>
        </ui-card>
        <ui-card
            [clickable]="true"
            [centered]="true"
            variant="outline"
            (click)="trackTimeOffAdjustmentsDataImport()"
            role="link"
            [routerLink]="['/time-off', 'v3', 'import', 'time-off-importers', 'time-off-adjustment']"
        >
            <h3 class="no-margin font-light">
                {{ 'time-off-v3.policyComponents.settings.importTimeOffData.timeOffAdjustmentsTitle' | translate }}
            </h3>
            <p class="subtitle">
                {{ 'time-off-v3.policyComponents.settings.importTimeOffData.timeOffAdjustmentsSubtitle' | translate }}
            </p>
        </ui-card>
    </div>
</ui-card>
